<template>
  <div :id="id">
    <span
      v-if="assessmentAdditionalInfoType.note === type"
      class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]"
    >
      Previously answered:
      <span
        :id="previousAnsweredId"
        class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[145%]"
        >{{ text }}</span
      >
    </span>
    <span
      v-if="
        type === assessmentAdditionalInfoType.notes &&
        props.noteText &&
        isHoverShowNote
      "
      class="tw-flex tw-items-center tw-gap-[4px] tw-w-[fit-content] tw-cursor-pointer"
      @click="emit('viewInfo')"
    >
      <PenIcon :size="14" class="tw-w-[14px] tw-h-[11px]" />
      <span
        class="tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]"
        >{{
          getComponentUiText(
            "app-component-assessments-additional-info-view-notes-1",
          )
        }}</span
      >
    </span>
    <Attachments
      v-if="assessmentAdditionalInfoType.attachment === type"
      :id="attachmentId"
      :attachments="attachmentsRef"
      :href="href"
      :max-shown="maxShown"
      :checklist-item-id="checklistItemId"
      :passkey-question="passkeyQuestion"
      :is-hovered="isHovered"
      :class-name-attachment="classNameAttachment"
      :is-vendor-request="isVendorRequest"
      @view-attachments="emit('viewAttachments')"
    />
  </div>
</template>

<script setup lang="ts">
import { IAttachment } from "@/interfaces/common/IAttachment";
import { PropType, onUpdated, ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import { assessmentAdditionalInfoType } from "@/utils/constants";
import PenIcon from "../svgs/penIcon.vue";
import Attachments from "../common/attachments.vue";

const props = defineProps({
  type: {
    type: String as PropType<assessmentAdditionalInfoType>,
    default: assessmentAdditionalInfoType.note,
  },
  attachments: {
    type: Array as PropType<Array<IAttachment>>,
    default: () => [],
  },
  text: {
    type: String as PropType<string>,
    default: "",
  },
  href: {
    type: String as PropType<string>,
    default: "#",
  },
  noteText: {
    type: String as PropType<string>,
    default: "",
  },
  checklistItemId: {
    type: Number,
    default: 0,
  },
  passkeyQuestion: {
    type: String,
    default: "",
  },
  isHovered: {
    type: Boolean,
    default: false,
  },
  maxShown: {
    type: Number,
    required: false,
    default: 3,
  },
  classNameAttachment: {
    type: String,
    default: "",
  },
  isVendorRequest: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  previousAnsweredId: {
    type: String,
    default: "",
  },
  attachmentId: {
    type: String,
    default: "",
  },
  isHoverShowNote: {
    type: Boolean,
    default: true,
  },
});

const attachmentsRef = ref(props.attachments);

onUpdated(() => {
  attachmentsRef.value = props.attachments;
});
const emit = defineEmits(["viewAttachments", "viewInfo"]);
</script>
